import { fetchUserDetailsActionTypes, UserDetailsActions } from "./userDetailsActions"
import { UserProfile, FetchErrorInfo, SuccessFetchingAction, ErrorFetchingAction } from "../../../.."
import { isEqualJson } from "../../../../utils/equal/equal"

export type UserDetailsState = {
    data?: UserProfile,
    error?: FetchErrorInfo
    isFetching: boolean
}

export const initialUserDetailsState: UserDetailsState = {
    isFetching: false
}

export const userDetailsReducer = (state: UserDetailsState = initialUserDetailsState, action: UserDetailsActions | {type: string, auth0_id: string, result: UserProfile}): UserDetailsState => {
    switch (action.type) {
        case fetchUserDetailsActionTypes.start: {
            return {
                isFetching: true,
                data: state.data
            }
        }
        case fetchUserDetailsActionTypes.success: {
            const successAction = action as SuccessFetchingAction<UserProfile>
            const newState: UserDetailsState = {
                ...state,
                isFetching: false,
            }
            if(!isEqualJson(successAction.result, state.data)){
                newState.data = successAction.result
            }
            return {
                ...newState
            }
        }
        case 'UPDATE_PARTIAL_USER_BY_UID': {
            const successAction = action as {auth0_id: string, result: Partial<UserProfile>}
            if(!successAction.auth0_id || !successAction.result || !Object.keys(successAction.result).length) return state

            if(!state?.data?.auth0_id) return state
            if(state?.data?.auth0_id !== successAction.auth0_id) return state
    
    
            return {
                ...state,
                data: {
                  ...state.data,
                  ...successAction.result
                }
            }
        }
    
        case fetchUserDetailsActionTypes.error: {
            const errorAction = action as ErrorFetchingAction
            return {
                isFetching: false,
                error: errorAction.error
            }
        }
        default:
            return state
    }
}